// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"f0248850","186":"a0b2191c","225":"0ed36bc0","344":"cc0c6f09","372":"342d3b75","377":"f4a6e799","738":"a8c42cb2","841":"be347e70","856":"8659b5c5"}[chunkId] + ".chunk.js";
};